import { styled } from 'styled-components';
import { breakpoints } from '../../../abstracts';
import { dontForwardProps } from '../../../util';
import { BaseTemplateStyles, BaseImageContainerStyles } from '../elements';
export const BaseSummaryTemplate = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-73wwy8-0"
})(["", ";padding-bottom:var(--aui-spacing-600);", "{grid-template-rows:auto auto 1fr;padding-left:var(--aui-spacing-300);padding-right:var(--aui-spacing-300);}", "{padding-left:var(--aui-spacing-600);padding-right:var(--aui-spacing-600);}", "{margin-left:auto;margin-right:auto;}", ""], BaseTemplateStyles, breakpoints.md, breakpoints.md2, breakpoints.xl, props => props.hasSupportivePanel ? `
    grid-template-areas:
      'image'
      'page-title'
      'supportive'
      'main-panel';
    
    grid-template-rows: auto auto auto 1fr;

    ${breakpoints.md} {
      grid-template-areas: 
        'image image'
        'page-title supportive'
        'main-panel supportive';

      grid-template-columns: 7fr 5fr;
      grid-template-rows: auto auto 1fr;
    }
  ` : `
    grid-template-areas:
      'image'
      'page-title'
      'main-panel';
    
    grid-template-rows: auto auto 1fr;

    ${breakpoints.lg} {
      grid-template-areas: 
        'image image image'
        '. page-title .'
        '. main-panel .';

      grid-template-columns: 2fr 8fr 2fr;
    }
  `);
export const ImageContainerWrapper = styled.div.withConfig({
  componentId: "aui__sc-73wwy8-1"
})(["", ";height:20rem;", "{height:25rem;}"], BaseImageContainerStyles, breakpoints.md2);
export const StyledSupportivePanelContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-73wwy8-2"
})(["grid-area:supportive;", "{position:relative;top:", ";}", "{top:", ";margin-left:var(--aui-spacing-300);}", "{margin-right:var(--aui-spacing-800);margin-left:var(--aui-spacing-500);}"], breakpoints.md, ({
  hasImage
}) => hasImage ? '-5.5rem' : 'var(--aui-spacing-400)', breakpoints.md2, ({
  hasImage
}) => hasImage ? '-10.5rem' : 'var(--aui-spacing-400)', breakpoints.xl);